import angular from 'angular'
import States from './pages/rfp.rfp-manager.states';
import RFPManagerRepository from 'root/rfp/rfp-manager/main/rfp.rfp-manager.repo';
import RfpManagerUi from './ui/rfp.rfp-manager.main.ui.module';

export default angular.module('rb.rfp.rfpManager.main', [RfpManagerUi.name])
  .config(States)
  .service('rfpManagerRepository', RFPManagerRepository)

